// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3cPtc","rootSuccess":"CompleteLink_rootSuccess__3r4pY","rootFailure":"CompleteLink_rootFailure__2Lacb","isDisabled":"CompleteLink_isDisabled__3GmE2"};